<template>
<div class="chapter">
<div class="inner_page">
<p class="toct"><span class="textStyle9">CONTENTS</span></p>
<p class="toc"><a href="#/Text/Chapter01"><span class="textStyle5">CHAPTER ONE</span></a></p>
<p class="toc"><a href="#/Text/Chapter02"><span class="textStyle5">CHAPTER TWO</span></a></p>
<p class="toc"><span href="#/Text/Chapter03" title="Link target outside of Sample"><span class="textStyle5">CHAPTER THREE</span></span></p>
<p class="toc"><span href="#/Text/Chapter04" title="Link target outside of Sample"><span class="textStyle5">CHAPTER FOUR</span></span></p>
<p class="toc"><span href="#/Text/Chapter05" title="Link target outside of Sample"><span class="textStyle5">CHAPTER FIVE</span></span></p>
<p class="toc"><span href="#/Text/Chapter06" title="Link target outside of Sample"><span class="textStyle5">CHAPTER SIX</span></span></p>
<p class="toc"><span href="#/Text/Chapter07" title="Link target outside of Sample"><span class="textStyle5">CHAPTER SEVEN</span></span></p>
<p class="toc"><span href="#/Text/Chapter08" title="Link target outside of Sample"><span class="textStyle5">CHAPTER EIGHT</span></span></p>
<p class="toc"><span href="#/Text/Chapter09" title="Link target outside of Sample"><span class="textStyle5">CHAPTER NINE</span></span></p>
<p class="toc"><span href="#/Text/Chapter10" title="Link target outside of Sample"><span class="textStyle5">CHAPTER TEN</span></span></p>
<p class="toc"><span href="#/Text/Chapter11" title="Link target outside of Sample"><span class="textStyle5">CHAPTER ELEVEN</span></span></p>
<p class="toc"><span href="#/Text/Chapter12" title="Link target outside of Sample"><span class="textStyle5">CHAPTER TWELVE</span></span></p>
<p class="toc"><span href="#/Text/Chapter13" title="Link target outside of Sample"><span class="textStyle5">CHAPTER THIRTEEN</span></span></p>
<p class="toc"><span href="#/Text/Chapter14" title="Link target outside of Sample"><span class="textStyle5">CHAPTER FOURTEEN</span></span></p>
<p class="toc"><span href="#/Text/Chapter15" title="Link target outside of Sample"><span class="textStyle5">CHAPTER FIFTEEN</span></span></p>
<p class="toc"><span href="#/Text/EPILOGUE" title="Link target outside of Sample"><span class="textStyle5">EPILOGUE</span></span></p>
<p class="toc"><span href="#/Text/AUTHORSNOTE" title="Link target outside of Sample"><span class="textStyle5">AUTHOR’S NOTE</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?3d43aefe